import {
    Columns,
    Element,
    List,
    Section,
    Title,
} from '@zmedia/bm-soccer-ui/components';
import cn from 'classnames';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import MatchService from '@zmedia/bm-soccer-ui/service/MatchService';
import { TIMER_GET_LIVE } from '@zmedia/bm-soccer-ui/constants';
import { liveMatchUpdate } from '@zmedia/bm-soccer-ui/redux/actions/match';
import { useDispatch } from 'react-redux';
import styles from './styles.module.scss';
import LiveService from '@zmedia/bm-soccer-ui/service/LiveService';
import { ColorUtils, Logger, ObjectUtils } from '@zmedia/bm-soccer-ui/utils';

interface IStat {
    name: string;
    home: number;
    away: number;
}

export function StatsSection(props: any) {
    const { id, isLive, statsMatch = {} } = props;
    const [data, setData] = useState<any>(statsMatch);
    const dispatch = useDispatch();

    const timeout = useRef<any>(0);

    const fetchData = (id: number) => {
        const fetch = isLive ? LiveService.getStats : MatchService.getStats;
        fetch(id)
            .then((resp) => {
                if (resp && resp.data) {
                    const { stats = {} } = resp.data;

                    if (ObjectUtils.isEmpty(stats)) {
                        const data = resp.data || {};
                        setData(data);
                    } else {
                        setData(stats);
                        if (isLive) {
                            dispatch(liveMatchUpdate(resp.data));
                            timeout.current = setTimeout(() => {
                                fetchData(id);
                            }, TIMER_GET_LIVE);
                        }
                    }
                }
            })
            .catch((err) => {
                if (err) {
                    Logger.error(err.err, 'getStatsInMatch fail|', err);
                }
            });
    };

    useEffect(() => {
        if (ObjectUtils.isEmpty(statsMatch) && id) {
            fetchData(id);
        }
        return () => {
            clearTimeout(timeout.current);
        };
    }, [id, isLive]);

    const stats: IStat[] = Object.keys(data)?.map((key) => data[key]);

    const renderStats = useCallback(() => {
        return stats.slice(1, stats.length)?.map((stat: IStat) => {
            return (
                <List.Item className={styles['stat-item']} key={stat.name}>
                    <Element
                        className={cn(styles['stat-value'], {
                            [styles['is-active']]: stat.home > stat.away,
                        })}
                        style={{
                            color:
                                !ColorUtils.isBrightnessColor(props?.teamColor?.hColor) &&
                                stat.home > stat.away
                                    ? '#fff'
                                    : '',
                        }}
                    >
                        {stat.home}
                    </Element>
                    <Element className={styles['stat-text']}>
                        {stat.name}
                    </Element>
                    <Element
                        className={cn(styles['stat-value'], {
                            [styles['is-active']]: stat.home < stat.away,
                        })}
                        style={{
                            color:
                                !ColorUtils.isBrightnessColor(props?.teamColor?.aColor) &&
                                stat.home < stat.away
                                    ? '#fff'
                                    : '',
                        }}
                    >
                        {stat.away}
                    </Element>
                </List.Item>
            );
        });
    }, [stats]);

    const { possession = {} } = data;

    if (ObjectUtils.isEmpty(possession)) {
        return null;
    }

    const totalPossession = possession.home + possession.away;
    const percentHPossession = Math.floor(
        (possession.home / totalPossession) * 100
    );
    const percentDraw = 1;
    const percentAPossession = 100 - percentHPossession - percentDraw;

    return (
        <Columns.Column>
            <Section className={styles['stats-section']} name="match-stats">
                <Title renderAs="h2">Thống kê</Title>
                <List>
                    <List.Item className={styles['stat-item']}>
                        <Element className={styles['stat-text']}>
                            {possession.name}
                        </Element>
                        <Element className={styles['elo-bar']}>
                            <Element
                                className={styles['home-bar']}
                                style={{
                                    width: percentHPossession + '%',
                                    color: ColorUtils.isBrightnessColor(
                                        props?.teamColor?.hColor
                                    )
                                        ? ''
                                        : '#fff',
                                }}
                            >
                                {percentHPossession}%
                            </Element>
                            <Element
                                className={styles['draw-bar']}
                                style={{ width: percentDraw + '%' }}
                            ></Element>
                            <Element
                                className={styles['away-bar']}
                                style={{
                                    width: percentAPossession + '%',
                                    color: ColorUtils.isBrightnessColor(
                                        props?.teamColor?.aColor
                                    )
                                        ? ''
                                        : '#fff',
                                }}
                            >
                                {100 - percentHPossession}%
                            </Element>
                        </Element>
                    </List.Item>
                    {renderStats()}
                </List>
            </Section>
        </Columns.Column>
    );
}

export default memo(StatsSection);
